import { useMutation } from '@tanstack/react-query';
import { Form, Formik } from 'formik';
import * as yup from 'yup';

import { useEffect } from 'react';
import categoryService from '../../../../../services/api/apps/appCategoryService';
import Modal from '../../../../../components/modals/Modal';
import { Button } from '../../../../../components/common';
import { FormInput, FormTextArea } from '../../../../../components/form';



function ModalAppCategoryForm({ open, category, onClose, onAdded, onUpdated }: Props) {
    useEffect(() => {
        if (open) {
            saveMutation.reset();
        }
    }, [open]);


    const saveMutation = useMutation({
        mutationFn: (data: any) => {
            return category ? categoryService.updateCategory(category.id, data) : categoryService.createCategory(data);
        }
    });


    const handleFormSubmit = async (formData: any, { resetForm }: any) => {
        saveMutation.mutate({ ...formData, moduleId: module.id }, {
            onSuccess: (data) => {
                onClose();

                if (category && onUpdated) {
                    onUpdated(data);
                }

                if (!category && onAdded) {
                    onAdded(data);
                }
            },
            onError: () => {
            }
        });
    }



    return (
        <Modal open={open} onClose={false ? () => null : onClose} closeOnOutsideClicked={false}>
            <div className="inline-block w-[36rem] max-w-full">
                <div className="flex justify-between mb-5 px-10 pt-8">
                    <h2 className="font-medium text-xl">
                        {category ? "Edit Category" : "Add Category"}
                    </h2>

                    <button type="button" onClick={onClose} className="text-2xl text-gray-500 [&:not(:disabled)]:hover:text-gray-600 dark:text-gray-600 dark:[&:not(:disabled)]:hover:text-gray-500 focus:outline-none" disabled={saveMutation.isPending}>
                        <i className="ri-close-line"></i>
                    </button>
                </div>

                <div className='max-h-[80vh] overflow-y-auto px-10 pb-6'>
                    <Formik
                        initialValues={{
                            name: category?.name || '',
                            description: category?.description || '',
                            //status: category?.status || 'ACTIVE',
                        }}
                        validationSchema={validationSchema}
                        onSubmit={handleFormSubmit}
                    >
                        {({ values, errors, touched, setErrors, setFieldValue, setFieldTouched, submitCount, isValid }) => (
                            <Form className="">
                                {/*  {
                                    saveMutation.error &&
                                    <p className='text-red-500 mb-4'>{saveMutation.error.message as unknown as string}</p>
                                } */}


                                <div className="mb-8">
                                    <label htmlFor="input-name" className='block text-sm mb-2'>Category Name</label>
                                    <FormInput type="text" name="name" id="input-name" className="w-full" placeholder="Enter category name" />
                                    {touched['name'] && errors['name'] && <p className='text-sm text-red-500 mt-2'>{errors['name'] as string}</p>}
                                </div>


                                <div className="mb-8">
                                    <label htmlFor="input-description" className='block text-sm mb-2'>Description</label>
                                    <FormTextArea name='description' id="input-description" className='w-full' placeholder="Type here" rows={4} />
                                    {touched['description'] && errors['description'] && <p className='text-sm text-red-500 mt-2'>Description is Required</p>}
                                </div>


                                {/* <div className='mb-10'>
                                    <label htmlFor="" className='block mb-2'>Status</label>
                                    <RadioGroupInput
                                        value={values['status']}
                                        options={[
                                            { label: "Active", value: 'ACTIVE' },
                                            { label: "Inactive", value: 'INACTIVE' },
                                        ]}
                                        onChange={(value) => setFieldValue('status', value)}
                                    />
                                </div> */}


                                <div className='flex justify-end items-center'>
                                    <Button type='button' onClick={onClose} className='!text-gray-500 dark:!text-white bg-gray-100 hocus:bg-gray-200  dark:bg-gray-800 dark:hocus:bg-gray-600 py-2.5 mr-6'>
                                        Cancel
                                    </Button>

                                    <Button type='submit' loading={saveMutation.isPending} className='' disabled={saveMutation.isPending}>
                                        {category ? "Save" : "Create Category"}
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </Modal>
    );
}


interface Props {
    open: boolean;
    category: any;
    onClose: () => void;
    onAdded?: (data: any) => void;
    onUpdated?: (data: any) => void;
}


const validationSchema = yup.object().shape({
    name: yup.string().trim().matches(/^[^!@#$%^&*()]+$/, 'No special characters are allowed').required('Category name is required'),
    description: yup.string().trim().required(),
    //status: yup.string().trim().required(),
});


export default ModalAppCategoryForm;